import { render } from "./StatsCards.vue?vue&type=template&id=61080e32&scoped=true"
import script from "./StatsCards.vue?vue&type=script&lang=js"
export * from "./StatsCards.vue?vue&type=script&lang=js"

import "./StatsCards.vue?vue&type=style&index=0&id=61080e32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61080e32"]])

export default __exports__